








































import { Vue, Component, Watch } from 'vue-property-decorator'
// import { Form } from 'vant'
import VueBase from '@/lib/vuebase'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import util from '@/lib/util'
import LoginResult from '@/store/models/login-result'
import app from '@/lib/app'
import AuthenticateModel from '@/store/models/authenticate-model'
@Component({
	components: {
		// 'van-form':Form
	}
})
export default class LoginView extends Vue {
	model: AuthenticateModel = new AuthenticateModel()
	loading: boolean = false
	private redirect?: string
	private otherQuery: Dictionary<string> = {}

	@Watch('$route', { immediate: true })
	private onRouteChange(route: Route) {
		// TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
		// See https://github.com/vuejs/vue-router/pull/2050 for details
		const query = route.query as Dictionary<string>
		if (query) {
			this.redirect = query.redirect
			this.otherQuery = this.getOtherQuery(query)
		}
	}

	async onSubmit(value: any) {
		this.loading = true
		this.model.openId = app.getOpenId()!
		await app.auth.authenticate(this.model).finally(()=> this.loading = false)
		// await this.$store.dispatch('permission/getCurrentUserPermissionKeys')
		await this.$store.dispatch('app/getCurrentUser')
		// this.$store.commit('app/setPassword', this.password)
		this.$router.push({
			path: this.redirect || '/',
			query: this.otherQuery
		})
		// this.loading = false
	}

	mounted() {
	}

	private getOtherQuery(query: Dictionary<string>) {
		return Object.keys(query).reduce((acc, cur) => {
			if (cur !== 'redirect') {
				acc[cur] = query[cur]
			}
			return acc
		}, {} as Dictionary<string>)
	}
}
